import requester from '@/utils/request'
export default {
  // 创作者订阅tier列表
  getSubscriptionList: (data: any) => requester.post('/subscribe-to-creator/tier/list', data, { headers: { isSeller: true } }),
  // 创作者新增订阅tier
  addSubscriptionTier: (data: any) => requester.post('/subscribe-to-creator/tier/save', data, { headers: { isSeller: true } }),
  // 创作者编辑修改订阅tier
  editSubscriptionTier: (data: any) => requester.post('/subscribe-to-creator/tier/update', data, { headers: { isSeller: true } }),
  // 创作者删除订阅tier
  deleteSubscriptionTier: (data: any) => requester.delete('/subscribe-to-creator/tier/delete', data, { headers: { isSeller: true } }),
  // 创作者高亮订阅tier
  highLightSubscriptionTier: (data: any) => requester.post('subscribe-to-creator/tier/high-light', data, { headers: { isSeller: true } }),
}
